import React from 'react';
import { Center, Image, Spinner, Text, Box } from '@gluestack-ui/themed';

import { useTranslation } from 'react-i18next';
import useTenantSettingsStore from '../common/context/TenantSettingsStore';
import MaintenanceMessage from '../common/components/MaintenanceMessage';

const SplashScreen = () => {
  const { t } = useTranslation();
  const { logoLargeUrl, tenantStatus, settings } = useTenantSettingsStore((state) => ({
    logoLargeUrl: state.settings?.imageAssetUrls?.logoLargeUrl,
    tenantStatus: state.status,
    settings: state.settings
  }));

  // Show spinner only while loading tenant settings
  if (tenantStatus === 'loading') {
    return (
      <Center w="100%" h="100%">
        <Spinner testID="spinner" size={30} mt={20} />
      </Center>
    );
  }

  // Show error if tenant settings failed to load - hang here like maintenance
  if (tenantStatus === 'error') {
    return (
      <Center w="100%" h="100%" bg="$backgroundLight0" p="$4">
        <MaintenanceMessage maintenanceState={settings?.maintenanceState} />
      </Center>
    );
  }


  return (
    <Center w="100%" h="100%">
      <Box w="80%" h={300}>

        <Image
          source={logoLargeUrl}
          alt="Logo"
          resizeMode="contain"
          w="100%"
          h={300}
          testID="logo"
        />
      </Box>
      <Text color="$textLight700" size="lg" mt={30} testID="initializing-text">{t('login.initializing')}</Text>
      <Spinner testID="spinner" size={30} mt={20} />
    </Center>
  );
};

export default SplashScreen;
